/**
 * Global configuration constants for Spacewalk application.
 * These are immutable values used throughout the application.
 */
const SpacewalkGlobals = {
    defaultGenomeAssembly: 'hg38'
};

export { SpacewalkGlobals };

